import { render } from "./PreloaderComponent.vue?vue&type=template&id=77ab2645&scoped=true"
import script from "./PreloaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PreloaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./PreloaderComponent.vue?vue&type=style&index=0&id=77ab2645&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ab2645"],['__file',"resources/themes/default/js/components/PreloaderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77ab2645"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77ab2645', __exports__)) {
    console.log('reload')
    api.reload('77ab2645', __exports__)
  }
  
  module.hot.accept("./PreloaderComponent.vue?vue&type=template&id=77ab2645&scoped=true", () => {
    console.log('re-render')
    api.rerender('77ab2645', render)
  })

}


export default __exports__